export default "__VITE_ASSET__BBE8BbhB__"